export enum Intent {
  MAKLER_SALE = 'MAKLER_SALE',
  MAYBE_MAKLER_SALE = 'MAYBE_MAKLER_SALE',
  INDEPENDENT_SALE = 'INDEPENDENT_SALE',
  INDEPENDENT_WITH_OFFER_SALE = 'INDEPENDENT_WITH_OFFER_SALE',
  MAYBE_AGENT_SALE = 'MAYBE_AGENT_SALE',
  RENT = 'RENT',
  LET = 'LET',
  MAKLER_LET = 'MAKLER_LET',
  MAYBE_MAKLER_LET = 'MAYBE_MAKLER_LET',
  INDEPENDENT_LET = 'INDEPENDENT_LET',
  BUY = 'BUY',
  BUY_WITH_SELL_OPTION = 'BUY_WITH_SELL_OPTION',
  BUY_MAYBE_WITH_SELL_OPTION = 'BUY_MAYBE_WITH_SELL_OPTION',
  PARTIAL_SALE = 'PARTIAL_SALE',
}

export enum IntentGermanString {
  MAKLER_SALE = 'Verkauf',
  BUY = 'Kauf ',
  RENT = 'Miete',
  LET = 'Vermietung',
}
